import {Component, input} from '@angular/core';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {Button} from 'primeng/button';

@Component({
  selector: 'ng-validation-errors-dialog',
  imports: [
    Button
  ],
  template: `
    <div style="margin-bottom: 20px; display: flex; gap: 20px">
      <div style="font-size: 2rem;color:var(--p-button-danger-background)">
        <i class="fa-regular fa-circle-exclamation"></i>
      </div>
      <div>
        @for (error of errors(); track error) {
          <div>
          {{ error }}
          </div>
        }
      </div>
    </div>
    <div style="display: flex; gap: 1rem;justify-content: flex-end;">
      <p-button severity="secondary" label="OK" (onClick)="cancel()"></p-button>
    </div>
  `
})
export class ValidationErrorsDialog {
  public errors = input<string[]>([])

  constructor(private ref: DynamicDialogRef,) {
  }

  cancel() {
    this.ref.close(false);
  }
}
